import * as React from 'react';

import * as styles from './styles.css';
import { Card } from '../../card';
import { PromoHeader } from '../PromoHeader';

export interface IPromoLayoutProps {
  onContainerScroll?(): void;
}

export function PromoLayout({ children, onContainerScroll }: React.PropsWithChildren<IPromoLayoutProps>) {
  return (
    <Card>
      <PromoHeader />
      <div className={styles['scrollable']} onScroll={onContainerScroll}>
        {children}
      </div>
    </Card>
  );
}
